import React, {useRef, useState} from 'react';
import styles from "./RemoveDuplicate.module.scss";

function RemoveDuplicate() {
    let inputRef = useRef();
    let outputRef = useRef();
    let [separator, setSeparator] = useState('line');

    function removeDuplicate(value, separator) {
        let output, delimiter;
        switch (separator) {
            case 'line':
                delimiter = '\n'
                break
            case 'word':
                value = value.replaceAll('\n', ' ')
                value = value.replaceAll('.', ' ')
                value = value.replaceAll(',', ' ')
                delimiter = ' '
                break
            default:
                delimiter = '\n'
        }
        output = new Set(value.trim().split(delimiter).map(item => item.trim()))
        output = [...output].filter(item => item !== "")
        return output.join(delimiter)
    }

    function handleInputChange(value) {
        outputRef.current.value = removeDuplicate(value, separator)
    }

    function handleSetDelimter(newSeparator) {
        setSeparator(newSeparator)
        outputRef.current.value = removeDuplicate(inputRef.current.value, newSeparator)
    }

    return (

        <div>
            <h1>Remove Duplicates</h1>

            <div className={styles.text}><label>Input text</label></div>
            <textarea ref={inputRef} className={styles.inputArea} onChange={e => handleInputChange(e.target.value)}
                      wrap='hard'/>
            <div className={styles.text}>
                <label>Unique </label>
                <select name='delimiter' onChange={e => handleSetDelimter(e.target.value)}>
                    <option name="line" value="line">Lines</option>
                    <option name="word" value="word">Words</option>
                </select>
            </div>
            <textarea ref={outputRef} className={styles.outputArea} wrap="hard" disabled/>
        </div>
    );
}

export default RemoveDuplicate;